import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';
var CryptoJS = require("crypto-js");

export const GetMyChallenges = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const RegisterAndSubmitChallenge = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `studentChallenge`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const UpdateMyChallenges = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `StudentChallenge/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetMyChallengesById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `StudentChallenge/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const getpdfUploadLink = async (challengeId, fileName) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `studentChallenge/upload/${challengeId}/${fileName}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const uploadPdf = async (uploadUrl, pdfData) => {
    var config = {
        method: 'put',
        url: uploadUrl,
        headers: {
            'Content-Type': 'application/pdf',
        },
        data: pdfData
    };
    return axios(config)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export  const handlePdfDownloadStudentChallenge = async (filename) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `studentchallenge/download/${filename}`,
    headers: {
        Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
        'Content-Type': 'application/json',
      },
  };
  return axios(config)
  .then(response => {
    var bytes = CryptoJS.AES.decrypt(response.data.data, '$seigolon#hcet');
    let decryptedURL = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const url = decryptedURL;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
  .catch(error => {
    // Handle download error
  });
};

// video upload


export const getVideoUploadLink = async (challengeId, fileName) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `studentChallenge/videoupload/${challengeId}/${fileName}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const uploadVideo = async (uploadUrl, pdfData) => {
    var config = {
        method: 'put',
        url: uploadUrl,
        headers: {
            'Content-Type': 'video/mp4',
        },
        data: pdfData
    };
    return axios(config)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}
export  const handleVideoDownloadStudentChallenge = async (filename) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `studentchallenge/videodownload/${filename}`,
    headers: {
        Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
        'Content-Type': 'application/json',
      },
  };
  return axios(config)
  .then(response => {
    var bytes = CryptoJS.AES.decrypt(response.data.data, '$hcet#uns');
    let decryptedURL = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const url = decryptedURL;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  })
  .catch(error => {
    // Handle download error
  });
};

